module.exports = __webpack_public_path__ + "static/img/page2-bc.48d890e2.png";